import { createStyles, Theme } from "@material-ui/core";
import { theme } from "../../theme/theme";

const svgPrev = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z" fill="${theme.palette.primary.main}"/></svg>`;
const svgNext = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z" fill="${theme.palette.primary.main}"/></svg>`;

export const styles = ({ spacing, palette }: Theme) => createStyles({
    nav: {
        position: "absolute",
        top: "50%",
        zIndex: 10,
        cursor: "pointer",
        border: "none",
        backgroundColor: "transparent",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: 10,
        height: 20,
        marginTop: -10 - (spacing.unit * 5),
        backgroundSize: "10px 20px",
        "&:focus": {
            outline: "none"
        }
    },
    navPrev: {
        left: spacing.unit * -2,
        backgroundImage: `url("data:image/svg+xml;charset=utf-8,${encodeURI(svgPrev)}")`
    },
    navNext: {
        right: spacing.unit * -2,
        backgroundImage: `url("data:image/svg+xml;charset=utf-8,${encodeURI(svgNext)}")`
    },
    swiper: {
        position: "relative",
        marginTop: spacing.unit * 4,
        width: "100%",
        "& .swiper-container": {
            paddingBottom: spacing.unit * 10
        },
        "& [class^='swiper-button']": {
            display: "none"
        },
        "& .swiper-pagination-bullet-active": {
            background: palette.primary.main
        },
        "& .swiper-pagination": {
            bottom:  spacing.unit * 4
        }

    }
});


// WEBPACK FOOTER //
// ./src/components/HomeSwiper/HomeSwiper.style.tsx